import { render } from "./transportadora-dropdown-item.vue?vue&type=template&id=722b40bc&scoped=true"
import script from "./transportadora-dropdown-item.vue?vue&type=script&lang=js"
export * from "./transportadora-dropdown-item.vue?vue&type=script&lang=js"

import "./transportadora-dropdown-item.vue?vue&type=style&index=0&id=722b40bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722b40bc"]])

export default __exports__